<template>
  <div class="flex-col page">
    <div class="flex-row justify-center self-stretch relative group" style="z-index: 1;">
      <img
        @click="$router.back()"
        class="image pos"
        src="https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=73da474f9f0a9d2a13c183e0f2ed8f88.png"
      />
      <span class="self-start text">视频拍摄</span>
    </div>
    <!-- 添加视频预览层 -->
    <video
      ref="cameraPreview"
      class="camera-preview"
      autoplay
      playsinline
      muted
    ></video>
    <!-- 现有内容继续 -->
    <div class="flex-col justify-start items-center self-stretch relative group_2">
      <img
        class="image_2"
        src="https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=2d94aa77027eb97c15b4766172ce2acf.png"
      />
      <div class="flex-col justify-start section pos_2">
        <div class="flex-col items-start group_3 ">
          <div class="scroll-up">

          <span class="font text_2">
            宝爸宝妈们，好消息来啦！2024年学平险保障范围全面扩大啦！
            <br />
          </span>
            <span class="mt-4 font text_3">
            孩子上学，安全和健康是头等大事。学平险一直是家长们为孩子保驾护航的“小能手”，如今它变得更强大了！
            <br />
          </span>
            <span class="mt-4 font text_4">
            今年的学平险不仅涵盖了意外伤害、疾病医疗等常见保障，还新增了许多实用的保障内容。比如，一些产品增加了校园内意外事故的赔付范围，甚至对一些特殊疾病也有了更全面的保障。无论是小磕小碰，还是突发疾病，都能给孩子更贴心的守护。
            <br />
          </span>

          </div>
        </div>
      </div>
    </div>
    <div class="flex-row justify-evenly items-center self-center section_2" :class="{'recording': recording}" @click="startRecord">
      <img
        class="image_3"
        src="https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=2a79936ddb1dc09013a0840292410011.png"
      />
      <img
        class="image_4"
        src="https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=04eaf0eabca598227d0209ea20b4708e.png"
      />
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      stream: null, // 用于存储摄像头视频流
      recording: false, // 用于标记是否正在录制视频
    };
  },
  created() {
    this.startCamera()
  },
  methods: {
    async startCamera() {
      try {
        // 请求摄像头权限并获取视频流
        this.stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: "user" } });
        // 将视频流绑定到 video 元素
        this.$refs.cameraPreview.srcObject = this.stream;
        // 可选：调整视频元素为全屏
        this.$refs.cameraPreview.style.display = "block";
        this.$refs.cameraPreview.style.position = 'fixed';
        this.$refs.cameraPreview.style.top = '0';
        this.$refs.cameraPreview.style.left = '0';
        this.$refs.cameraPreview.style.width = '100%';
        this.$refs.cameraPreview.style.height = '100%';
        this.$refs.cameraPreview.style.zIndex = '0'; // 确保在最上层
      } catch (error) {
        console.error('无法访问摄像头:', error);
      }
    },
    stopCamera() {
      if (this.stream) {
        // 停止所有轨道
        this.stream.getTracks().forEach(track => track.stop());
        this.stream = null;
        // 移除视频元素样式
        this.$refs.cameraPreview.srcObject = null;
        this.$refs.cameraPreview.style.position = '';
        this.$refs.cameraPreview.style.top = '';
        this.$refs.cameraPreview.style.left = '';
        this.$refs.cameraPreview.style.width = '';
        this.$refs.cameraPreview.style.height = '';
        this.$refs.cameraPreview.style.zIndex = '';
      }
    },
    startRecord() {
      if (this.recording) {
        this.recording = true;
        this.$router.push({ name: 'shipinjianjizhong' });
      } else {
        this.recording = true;
      }
    }
  },
  beforeUnmount() {
    // 组件卸载时停止摄像头
    this.stopCamera();

  },
};
</script>

<style scoped lang="less">
  .page {
    position: relative;
    padding: 14px 16px 60px;
    background-color: rgb(17, 17, 17);
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    height: 100%;
    .group {
      padding-bottom: 10px;
      .image {
        border-radius: 5px;
        width: 24px;
        height: 24px;
      }
      .pos {
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
      }
      .text {
        color: rgb(255, 255, 255);
        font-size: 18px;
        font-family: 思源黑体;
        font-weight: 700;
        line-height: 17px;
      }
    }
    .group_2 {
      margin-top: 37px;
      padding-top: 142px;
      .image_2 {
        width: 320px;
        height: 352px;
      }
      .section {
        padding: 23px 0 32px;
        background-color: rgba(108, 108, 108, 0.5);
        border-radius: 20px;
        .group_3 {
          margin: 0 13px;
          overflow: hidden;
          height: 217px;
          .font {
            font-size: 16px;
            font-family: 思源黑体;
            letter-spacing: 2px;
            line-height: 19px;
            color: rgb(249, 249, 249);
          }
          .text_2 {
            width: 309.5px;
          }
          .text_3 {
            width: 320.5px;
          }
          .text_4 {
            margin-bottom: -64px;
            width: 321px;
          }
        }
      }
      .pos_2 {
        position: absolute;
        left: 12px;
        right: 12px;
        top: 0;
      }
    }
    .section_2 {
      margin-top: 40px;
      padding: 22px 16px;
      background-color: rgb(85, 239, 227);
      border-radius: 50%;
      width: 70px;
      z-index: 3;
      .image_3 {
        width: 30.5px;
        height: 27px;
      }
      .image_4 {
        width: 10px;
        height: 20px;
      }
      &.recording {
        background-color: rgb(255, 102, 102);
      }
    }
    .camera-preview {
      /* 默认隐藏，通过 JavaScript 控制显示 */
      display: none;
      object-fit: cover; /* 保持视频比例并覆盖整个元素 */
    }
    @keyframes scrollUp {
      0% {
        transform: translateY(0%);
      }
      100% {
        transform: translateY(-100%);
      }
    }
    .scroll-up {
      animation: scrollUp 60s linear 5s infinite; /* 调整时间以改变滚动速度 */
    }
  }
</style>
